/*
  APBD 09/29/26: Mad Hatter style collection cards.
  Products are one-per-design, with the hat style baked into the Color option
  ("7 Panel Black", "Trucker White", "Flat Bill Brown/White", "Retro Black").
  On a style collection, this script makes each card match that style:
    1. Hides swatches for other styles
    2. Swaps the main card image to the first matching style's variant image
    3. Points the card links at that variant (?variant=ID)
    4. Hides the card entirely if that style is sold out for this design
  The style key comes from blocks/_product-card.liquid, based on collection handle.

  APBD 10/01/26: Image swap is now guarded. The new image is preloaded first and
  only replaces the theme's image (and srcset) once it has actually loaded.
  If the swapped image ever fails, the original src + srcset are restored.
  Fixes broken main card images reported on some iPhones (Retro Signatures).
*/
const tag = document.querySelector('script[data-mh-style-key]');
const KEY = tag ? tag.dataset.mhStyleKey : '';
const norm = (s) => (s || '').toLowerCase().replace(/[\s\-_]/g, '');

function swatchImageUrl(input) {
  const label = input.closest('label');
  const swatch = label && label.querySelector('.swatch');
  if (!swatch) return null;
  const bg = swatch.style.getPropertyValue('--swatch-background') || '';
  const m = bg.match(/url\((['"]?)(.*?)\1\)/);
  if (!m) return null;
  try {
    const u = new URL(m[2].trim(), location.href);
    u.searchParams.set('width', '1000');
    u.searchParams.delete('height');
    u.searchParams.delete('crop');
    return u.toString();
  } catch (e) {
    return null;
  }
}

// APBD 10/01/26: Only swap once the new image is confirmed loadable.
function swapCardImage(img, src) {
  if (img.dataset.mhSwapped === src) return;
  img.dataset.mhSwapped = src;
  const origSrc = img.getAttribute('src');
  const origSrcset = img.getAttribute('srcset');
  const test = new Image();
  test.onload = () => {
    if (!test.naturalWidth) return;
    img.addEventListener(
      'error',
      () => {
        if (origSrcset) img.setAttribute('srcset', origSrcset);
        if (origSrc) img.setAttribute('src', origSrc);
      },
      { once: true }
    );
    img.removeAttribute('srcset');
    img.src = src;
  };
  test.onerror = () => {}; // keep the theme's original image
  test.src = src;
}

function styleCard(card) {
  if (card.dataset.mhStyle === KEY) return;
  const inputs = [...card.querySelectorAll('.variant-option--swatches input[type="radio"]')];
  if (!inputs.length) return;
  card.dataset.mhStyle = KEY;

  let match = null;
  let fallback = null;
  for (const input of inputs) {
    const wrap = input.closest('.variant-option__swatch');
    const inStock = input.dataset.hasAvailableVariant === 'true' || input.dataset.optionAvailable === 'true';
    if (norm(input.value).startsWith(KEY)) {
      if (inStock && !fallback) fallback = input;
      if (!match && inStock && swatchImageUrl(input)) match = input;
    } else if (wrap) {
      wrap.hidden = true;
      wrap.style.display = 'none';
    }
  }
  match = match || fallback;

  // APBD 09/29/26: If this design has no in-stock variant in this style,
  // hide the whole card so the style page only shows hats you can buy in that style.
  if (!match) {
    const item = card.closest('.product-grid__item') || card.closest('li');
    if (item) {
      item.hidden = true;
      item.style.display = 'none';
    }
    return;
  }

  const variantId = match.dataset.variantId;
  if (variantId) {
    card.querySelectorAll('a[href*="/products/"]').forEach((a) => {
      try {
        const u = new URL(a.getAttribute('href'), location.href);
        u.searchParams.set('variant', variantId);
        a.setAttribute('href', u.pathname + u.search);
      } catch (e) {}
    });
  }

  const src = swatchImageUrl(match);
  const img = card.querySelector('.card-gallery img');
  if (src && img) swapCardImage(img, src);
}

function run() {
  if (!KEY) return;
  document.querySelectorAll('product-card').forEach(styleCard);
}

if (KEY) {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      run();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
}
